<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("rawmaterials", 1) }}</div>
        <div class="section-subTitle my-2">
          {{ $t("listofall") }} {{ $tc("rawmaterials", 1) }}
          {{ $t("incinematic") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Raw Material')"
          variant="default"
          to="add-raw-material"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          @input="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              filter_is_active = filterIsActive;
              getRawMaterialsList();
            }
          "
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <b-button variant="default" @click="onFetch()" class="btn-blue">{{
          $t("fetch")
        }}</b-button>
        <div
          v-if="rawMaterials.length > 0"
          class="d-flex justify-content-end align-items-center"
        >
          Download as:
          <img
            @click="excelDownload()"
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(rm, rmkey) in rawMaterials"
        :key="rmkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ rm.rm_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Raw Material')"
                  to="edit-raw-material"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item to="view-raw-material">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />
                employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <StatusDot />
            </div>
          </div>
        </div>
      </div>
      <div v-if="rawMaterials.length == 0">
        <h5>No Records Found</h5>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th class="text-left">Report Code</th>
          <th class="text-left">GL Code</th>
          <th class="text-left">GL Description</th>
          <th>
            <img
              v-if="this.columnName != 'rm_name'"
              @click="onSortValue('rm_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('rm_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('rm_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("rawmaterials", 2) }}
          </th>
          <th class="text-left">UOM</th>
          <th class="text-left">Is Inventory</th>
          <th v-if="stock_direct_transfer" class="text-center">
            {{ $t("addDirectlyToStore") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="rawMaterials.length > 0">
        <tr v-for="(rm, rmkey) in rawMaterials" :key="rmkey">
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  rm.rm_is_active === 'Y'
                    ? 'active'
                    : rm.rm_is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Raw Material')"
                  @click="goToRoute('/fnb/edit-raw-material', rm)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-raw-material', rm)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="rm.rm_is_active === 'Y' ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'Raw Material')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/fnb/edit-raw-material', rm)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
              <div
                class="ml-2 clickable-icon"
                @click="goToRoute('/fnb/view-raw-material', rm)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td class="text-left">{{ rm.report_code }}</td>
          <td class="text-left">{{ rm.gl_account }}</td>
          <td class="text-left">{{ rm.gl_desc }}</td>
          <td class="text-left">{{ rm.rm_name }}</td>
          <td class="text-left">{{ rm.uom_unit }}</td>
          <td class="text-left">{{ rm.is_inventory }}</td>
          <td v-if="stock_direct_transfer" class="text-center">
            <span
              @click="onShowModal(rmkey, rm)"
              class="border rounded px-2 py-1 c-pointer font-small-caps"
              >{{ $t("proceed") }}</span
            >
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="stock_direct_transfer ? 3 : 2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      size="lg"
      hide-footer
      id="unit-measurements-modal"
      ref="unit-measurements-modal"
      :title="selectedRawMaterial.rm_name"
    >
      <form class="w-100">
        <div class="row">
          <div class="col-lg-6 mb-4">
            <div class="dropdown-curve-container">
              <label :class="rawMaterialsToStore.cinema_id ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="rawMaterialsToStore.selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 mb-4">
            <div class="dropdown-curve-container">
              <label :class="rawMaterialsToStore.v_id ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor", 1) }}</label
              >
              <b-dropdown
                :text="rawMaterialsToStore.selectedVendor"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Vendor"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchVendor($event.target.value)"
                    v-on:keydown="onSearchVendor($event.target.value)"
                    v-model="searchVendor"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Vendor, VendorIndex) in Vendors"
                  :key="VendorIndex"
                  v-on:click="onSelectVendor($event, Vendor)"
                  >{{ Vendor.v_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 mb-5">
            <div class="input-material">
              <input
                placeholder="."
                v-model="rawMaterialsToStore.quantity"
                @keyup="onChangeQuantity($event.target.value)"
                @keydown="onChangeQuantity($event.target.value)"
                type="text"
                name="Quantity"
                id="Quantity"
              />
              <label>{{ $t("enter") }} {{ $t("quantity") }}</label>
            </div>
          </div>
          <div class="col-lg-6 mb-5">
            <div class="dropdown-curve-container">
              <label :class="rawMaterialsToStore.uom_id ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("unitofmeasurement", 1) }}</label
              >
              <b-dropdown
                :text="rawMaterialsToStore.selectedUnitMeasurements"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(
                    UnitMeasurement, UnitMeasurementIndex
                  ) in unitMeasurements"
                  :key="UnitMeasurementIndex"
                  v-on:click="onSelectUnitMeasurement($event, UnitMeasurement)"
                  >{{ UnitMeasurement.uom_unit }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-12 text-center">
            <button
              @click.prevent.stop="onAddRawMaterialIntoStore"
              class="btn-blue"
            >
              {{ $t("submit") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFNBService from "@/services/PosFnbService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      //for search
      debounce: null,
      searchValue: "",
      searchKey: "rm_name", //the key name in your table
      stock_direct_transfer: false,
      gridView: false,
      listView: true,
      rawMaterials: [],
      rawMaterialsExcel: [],
      Cinemas: [],
      CinemasCopy: [],
      Vendors: [],
      VendorsCopy: [],
      searchCinema: "",
      searchVendor: "",

      viewingnumbers: [],
      unitMeasurements: [],
      rawMaterialsToStore: {
        selectedCinema: "",
        cinema_id: null,
        selectedVendor: "",
        v_id: null,
        selectedUnitMeasurements: "",
        uom_id: null,
        quantity: null,
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "desc",
      columnName: "rm_id",

      poi_price: 0,
      poi_price_copy: 0,
      poi_tax_amount: 0,
      poi_tax_amount_copy: 0,
      poi_total_amount: 0,
      vendor_rate_id: null,
      selectedRawMaterial: {
        rm_name: null,
        rm_id: null,
        index: null,
      },
      filter_is_active: "Y",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.getCinemasList();
    this.getviewingnumber();
    this.stock_direct_transfer =
      this.secureStore.get("BRGLOPSTDITR") &&
      this.secureStore.get("BRGLOPSTDITR") == "Y"
        ? true
        : false;
  },
  mounted() {
    // this.getRawMaterialsList();
    this.getUnitMeasurementList();
    // this.getRawMaterialsListExcel();
  },
  methods: {
    onFetch: function () {
      this.getRawMaterialsList();
      this.getRawMaterialsListExcel();
    },
    excelDownload() {
      let temp_data = this.rawMaterialsExcel;
      let dateparse = function (value) {
        if (!value) {
          return "-";
        } else if (value === "Invalid date") {
          return "-";
        } else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid()) {
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        } else {
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
        }
      };
      let data = [
        {
          sheet: "Raw Material",

          columns: [
            {
              value: "rm_code",
              label: "Raw Material Code",
            },
            {
              value: "rm_name",
              label: "Raw Material",
            },
            {
              value: "report_code",
              label: "Report Code",
            },
            {
              value: "gl_account",
              label: "GL Account",
            },
            {
              value: "gl_desc",
              label: "GL Description",
            },
            {
              value: "rmc_category",
              label: "Raw Material Category",
            },
            {
              value: "uom_unit",
              label: "Unit Of Measurement",
            },
            {
              value: "is_inventory",
              label: "Is Inventory",
            },
            {
              value: (row) => (row.recco == "Y" ? "Active" : "Inactive"),
              label: "Is Recco",
            },
            {
              value: (row) =>
                row.is_expiry_available == "Y" ? "Active" : "Inactive",
              label: "Is Expiry Available",
            },
            {
              value: (row) => (row.rm_is_active == "Y" ? "Active" : "Inactive"),
              label: "Status",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `Raw_Material${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchVendor: function (value) {
      if (this.searchVendor && this.searchVendor.length > 0) {
        this.Vendors = this.VendorsCopy.filter((x) => {
          if (
            x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Vendors = this.VendorsCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRawMaterialsList();
      } else {
        this.currentPage = event;
        this.getRawMaterialsList();
      }
    },
    onShowModal: function (Index, RawMaterial) {
      this.selectedRawMaterial = {
        ...this.selectedRawMaterial,
        index: Index,
        ...RawMaterial,
      };
      this.rawMaterialsToStore = {
        selectedCinema: "",
        cinema_id: null,
        selectedUnitMeasurements: "",
        uom_id: null,
        quantity: null,
      };
      this.$refs["unit-measurements-modal"].show();
    },
    onAddRawMaterialIntoStore: function () {
      if (
        !this.rawMaterialsToStore.cinema_id ||
        String(this.rawMaterialsToStore.cinema_id).length === 0
      ) {
        return this.$toasted.show("Please Select Cinema");
      } else if (
        !this.rawMaterialsToStore.v_id ||
        String(this.rawMaterialsToStore.v_id).length === 0
      ) {
        return this.$toasted.show("Please Select Vendor");
      } else if (
        !this.rawMaterialsToStore.quantity ||
        String(this.rawMaterialsToStore.quantity).length === 0
      ) {
        return this.$toasted.show("Please Enter Quantity");
      } else if (
        !this.rawMaterialsToStore.uom_id ||
        String(this.rawMaterialsToStore.uom_id).length === 0
      ) {
        return this.$toasted.show("Please Select Unit Of Measurement");
      } else {
        let payload = {
          po_date: new Date(),
          v_id: this.rawMaterialsToStore.v_id,
          cinema_id: this.rawMaterialsToStore.cinema_id,
          po_total_amount: this.poi_total_amount,
          po_lock: true,
          remarks: null,
          po_is_active: true,
          vendorList: [
            {
              rm_id: this.selectedRawMaterial.rm_id,
              vendor_rate_id: this.vendor_rate_id,
              poi_qty: this.rawMaterialsToStore.quantity,
              uom_id: this.rawMaterialsToStore.uom_id,
              poi_price: this.poi_price,
              poi_tax_amount: this.poi_tax_amount,
              po_total_amount: this.poi_total_amount,
              poi_total_amount: this.poi_total_amount,
              poi_is_active: this.poi_is_active,
            },
          ],
          // stock_quantity:
        };
        PosFNBService.AddPurchaseOrder(payload)
          // PosFnbService.OnAddRawMaterialIntoStore(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show("Item Added to Store.");
              this.$refs["unit-measurements-modal"].hide();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getRawMaterialsList();
    },
    getCinemasList: function () {
      this.Cinemas = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.rows = data.totalRows;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getUnitMeasurementList: function () {
      this.Cinemas = [];
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.unitMeasurements = data.Records;
            // this.rows = data.totalRows;
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    //search
    onSearch(event) {
      // this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.getRawMaterialsList();
      }, 500);
    },

    getRawMaterialsList: function () {
      this.rawMaterials = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: this.filter_is_active,
      };
      PosFNBService.GetRawMaterialsList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.rawMaterials = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },

    getRawMaterialsListExcel: function () {
      this.rawMaterialsExcel = [];
      let payload = {
        limit: this.perPageExcel,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: this.filter_is_active,
      };
      PosFNBService.GetRawMaterialsList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.rawMaterialsExcel = data.Records;
            console.log(" this.rawMaterialsExcel:", this.rawMaterialsExcel);
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectCinema: function (event, params) {
      this.rawMaterialsToStore.selectedCinema = params.cine_name;
      this.rawMaterialsToStore.cinema_id = params.cine_id;
      this.getVendorsList();
    },
    getVendorsList: function () {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.VendorsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectVendor(event, Vendor) {
      this.rawMaterialsToStore.selectedVendor = Vendor.v_name;
      this.rawMaterialsToStore.v_id = Vendor.v_id;
      this.getVendorRateDetails();
    },
    getVendorRateDetails() {
      let payload = {
        vendor_id: this.rawMaterialsToStore.v_id,
      };
      PosFNBService.GetVendorRateDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let checkVendorRate = data.Records.filter((x) => {
              return x.rawmaterial_id == this.selectedRawMaterial.rm_id;
            });
            if (checkVendorRate && checkVendorRate.length > 0) {
              let x = checkVendorRate[0];
              console.log("x :>> ", x);
              this.poi_price = parseFloat(x.vr_rate) / parseInt(x.vr_qty);
              this.poi_price_copy = parseFloat(x.vr_rate) / parseInt(x.vr_qty);
              this.poi_tax_amount =
                parseFloat(x.vr_tax_amount) / parseInt(x.vr_qty);
              this.poi_tax_amount_copy =
                parseFloat(x.vr_tax_amount) / parseInt(x.vr_qty);
              this.poi_total_amount = this.poi_price + this.poi_tax_amount;
              this.vendor_rate_id = x.vr_id;
              this.onSelectUnitMeasurement(null, {
                uom_unit: x.uom_unit,
                uom_id: x.uom_id,
              });
              console.log("this.poi_total_amount :>> ", this.poi_total_amount);
            } else {
              this.rawMaterialsToStore.selectedVendor = "";
              this.rawMaterialsToStore.v_id = null;
              this.$toasted.show("No Vendor Rates found for this item");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onChangeQuantity: function (value) {
      let Qty = parseInt(value);
      this.poi_price = this.poi_price_copy * Qty;
      this.poi_tax_amount = this.poi_tax_amount_copy * Qty;
      this.poi_total_amount = this.poi_price + this.poi_tax_amount;
      console.log("this.poi_total_amount onchange:>> ", this.poi_total_amount);
    },
    onSelectUnitMeasurement: function (event, params) {
      this.rawMaterialsToStore.selectedUnitMeasurements = params.uom_unit;
      this.rawMaterialsToStore.uom_id = params.uom_id;
    },
    goToRoute: function (path, { rm_id }) {
      this.$router.push({
        path: path,
        query: {
          rm_id: rm_id,
        },
      });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
  watch: {
    filter_is_active(newVal) {
      this.getRawMaterialsList();
      this.getRawMaterialsListExcel();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/rawMaterials.vue